import { useMemo } from 'react';
import { keyBy } from 'lodash';
import type {
  BaseReferenceDataNationalNorm,
  ReferenceDataNationalNormDictionary
} from 'services/assist-api/entities/reference-data-national-norm/reference-data-national-norms';
import { getActiveDataForStartDate } from './start-date.helpers';

// Needs to be done after checking the national norm dates:
export function keyedNationalNorms(
  nationalNorms: BaseReferenceDataNationalNorm[]
): ReferenceDataNationalNormDictionary {
  const nationalNormsFiltered = nationalNorms.map((norm) => ({
    ...norm,
    std: norm.scaleStd,
    mean: norm.scaleMean,
    minimum: norm.scaleMinimum,
    median: norm.scaleMedian,
    maximum: norm.scaleMaximum,
    lowerQuartile: norm.scaleLowerQuartile,
    upperQuartile: norm.scaleUpperQuartile
  }));

  return keyBy(nationalNormsFiltered, (norm) => norm.level.id);
}

export default function useNationalNormsForStartDate(
  allNationalNorms: BaseReferenceDataNationalNorm[] | undefined,
  startDate: string | undefined
): ReferenceDataNationalNormDictionary | undefined {
  return useMemo((): ReferenceDataNationalNormDictionary | undefined => {
    if (allNationalNorms && startDate) {
      const filteredNationalNorms = getActiveDataForStartDate(allNationalNorms, startDate);
      return keyedNationalNorms(filteredNationalNorms);
    }
    return undefined;
  }, [startDate, allNationalNorms]);
}
